/**
 * Sports Realm — scroll reveal.
 *
 * Mirrors the approved mockup exactly:
 *   IntersectionObserver, threshold 0.12, rootMargin "0px 0px -8% 0px",
 *   unobserve after firing. Respects prefers-reduced-motion.
 *
 * Elements opt in with [data-sr-reveal]; the observer adds .sr-is-visible.
 * Re-runs on Shopify section load so Theme Editor edits stay visible.
 */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function showAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('sr-is-visible');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('sr-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    return observer;
  }

  function observe(root) {
    var nodes = (root || document).querySelectorAll('[data-sr-reveal]:not(.sr-is-visible)');
    if (!nodes.length) return;

    if (REDUCE || !('IntersectionObserver' in window)) {
      showAll(nodes);
      return;
    }

    var io = getObserver();
    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe(document);
    });
  } else {
    observe(document);
  }

  // Theme editor: a re-rendered section brings new nodes with it.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
